import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import ProgressiveImage from "react-progressive-image";
import Customization from "../../Items/Customization";
import { addProduct, removeProduct } from "../../../../services/cart/actions";
import { connect } from "react-redux";
import FloatCart from "../../FloatCart";
import { Helmet } from "react-helmet";
import Icon from '../../../helpers/icon';

class SingleItemStore extends Component {
    static contextTypes = {
        router: () => null,
    };
    state = {
        tags: [],
        update: true,
        item: []
    };

    componentDidMount() {
        axios
            .post('https://pykin.in/public/api/get-single-item', {
                'id': this.props.match.params.id
            })
            .then((response) => {
                const data = response.data;
                this.setState({
                    item: data,
                });

            });
    }

    forceStateUpdate = () => {
        setTimeout(() => {
            this.forceUpdate();
            if (this.state.update) {
                this.setState({ update: false });
            } else {
                this.setState({ update: true });
            }
        }, 100);
    };

    render() {
        localStorage.setItem("font-css", "* { font-family: 'Poppins', sans-serif; }")

        // console.log(this.props.items);
        const { addProduct, removeProduct, cartProducts } = this.props;
        const { item } = this.state;
        return (
            <React.Fragment >
                <Helmet>
                    <style type="text/css">{localStorage.getItem("font-css")}</style>
                </Helmet>
                <div className="d-flex  " style={{ justifyContent: 'space-between', marginBottom: '4%', padding: '10px' }}>
                    <span onClick={this.context.router.history.goBack} style={{ "backgroundColor": "#00000012", "borderRadius": "100%", "padding": "3px" }}><Icon icon="arrow-left" /></span>
                    <span onClick={() => this.context.router.history.push("/")} style={{ "backgroundColor": "#00000012", "borderRadius": "100%", "padding": "3px" }}><Icon icon="home" /></span>
                </div>

                <div style={{width: '100vw'}}>
                    <div className="image-parent ">
                        <img alt={item.name} src={'https://pykin.in/' + item.image} style={{ width: '100vw', height: '100vw' }} />
                    </div>

                    <div style={{ margin: '7vw' }}>
                        <div className="items-text" style={{ "textOverflow": "ellipsis", "overflowY": "clip", "fontWeight": "600", "fontSize": "21px" }}>
                            {item.name}
                        </div>
                        <div className="items-sub" style={{ textOverflow: 'ellipsis', overflowY: 'clip', fontSize: 'large' }}>
                            {item.short_desc}
                        </div>
                        <div className="items-price" style={{ "textOverflow": "ellipsis", "overflowY": "clip", "fontSize": "20px", "fontWeight": "700" }}>
                            ₹{item.price}
                        </div>

                        <div className="add-item-switches" style={{ "position": "relative", "top": "-12vh", "left": "64vw" }}>
                            {cartProducts.find((cp) => cp.id === item.id) !==
                                undefined && (
                                    <React.Fragment>
                                        <div className="item-actions  mt-2">
                                            <div
                                                className="btn-group btn-group-sm border "
                                                role="group"
                                                aria-label="btnGroupIcons1"
                                                style={{ borderRadius: '0.5rem' }}
                                            >
                                                {item.is_active ? (
                                                    <React.Fragment>
                                                        {item.addon_categories.length ? (
                                                            <button
                                                                disabled
                                                                type="button"
                                                                className="btn btn-add-remove"
                                                                style={{
                                                                    width: '2.7rem',

                                                                    color: localStorage.getItem("cartColor-bg"),
                                                                }}
                                                            >
                                                                <span class="btn-dec">-</span>
                                                                <Ink duration="500" />
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-add-remove"
                                                                style={{
                                                                    width: '2.7rem',

                                                                    color: localStorage.getItem("cartColor-bg"),
                                                                }}
                                                                onClick={() => {
                                                                    item.quantity = 1;
                                                                    removeProduct(item);
                                                                    this.forceStateUpdate();
                                                                }}
                                                            >
                                                                <span class="btn-dec">-</span>
                                                                <Ink duration="500" />
                                                            </button>
                                                        )}
                                                        <span className="pl-2 pr-2" style={{ "color": "rgb(153 32 28)", "display": "flex", "justifyContent": "center", "alignItems": "center", "padding": "0 10px", "fontWeight": "500", "fontSize": "1rem", "borderTop": "1px solid #efefef", "borderBottom": "1px solid #efefef" }}>
                                                            <React.Fragment>
                                                                {
                                                                    cartProducts.find(
                                                                        (cp) =>
                                                                            cp.id ===
                                                                            item.id
                                                                    ).quantity
                                                                }
                                                            </React.Fragment>
                                                        </span>


                                                        {item.addon_categories.length ? (
                                                            <Customization
                                                                product={item}
                                                                addProduct={addProduct}
                                                                forceUpdate={this.forceStateUpdate}
                                                            />
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-add-remove robo"
                                                                style={{
                                                                    width: '2.7rem',

                                                                    color: localStorage.getItem("cartColor-bg"),
                                                                }}
                                                                onClick={() => {

                                                                    addProduct(item);
                                                                    this.forceStateUpdate();
                                                                }}
                                                            >
                                                                <span className="robo" style={{ "fontSize": "1.4rem", "lineHeight": "14px", "color": "#282c3f", "fontWeight": "500" }}>+</span>
                                                                <Ink duration="500" />
                                                            </button>
                                                        )}
                                                    </React.Fragment>
                                                ) : (
                                                    <div className="robo text-danger text-item-not-available">
                                                        {localStorage.getItem("cartItemNotAvailable")}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}

                            {cartProducts.find((cp) => cp.id === item.id) ===
                                undefined && (
                                    <React.Fragment>
                                        <div className="item-actions mt-2">
                                            {item.is_active ? (
                                                <React.Fragment>
                                                    {item.addon_categories.length ? (
                                                        <Customization
                                                            product={item}
                                                            addProduct={addProduct}
                                                            forceUpdate={this.forceStateUpdate}
                                                        />
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="robo btn btn-success"
                                                            style={{ "position": "relative", "border": "0.7px solid #AEAEAE", "color": "#99201c", "width": "70px", "backgroundColor": "rgb(255, 255, 255)", "letterSpacing": "0.8px", "borderRadius": "3px" }}
                                                            onClick={() => {
                                                                item.quantity = 1;
                                                                addProduct(item);
                                                                this.forceStateUpdate();
                                                            }}
                                                        >
                                                            ADD
                                                            <span style={{ "position": "absolute", "top": "0px", "right": "4px" }}>+</span>
                                                            <Ink duration="500" />
                                                        </button>
                                                    )}
                                                </React.Fragment>
                                            ) : (
                                                <div className="robo text-danger text-item-not-available">
                                                    {localStorage.getItem("cartItemNotAvailable")}
                                                </div>
                                            )}
                                        </div>
                                    </React.Fragment>
                                )}
                        </div>
                        {item.desc !== null ? (
                            <div className="mt-2 mb-100">
                                <hr />
                                <div className="items-text" style={{ "textOverflow": "ellipsis", "overflowY": "clip", "fontWeight": "600", "fontSize": "15px" }}>Full Description</div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.desc,
                                    }}
                                />
                            </div>
                        ) : (
                            <br />
                        )}
                    </div>
                </div>

                <FloatCart />

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    promo_slides: state.promo_slides.promo_slides,
    user: state.user.user,
    locations: state.locations.locations,
    languages: state.languages.languages,
    cartProducts: state.cart.products,
});




export default connect(
    mapStateToProps,
    {
        addProduct,
        removeProduct,
    }
)(SingleItemStore);